import axios from 'axios';

// Catálogo de Argentina (24 provincias y sus localidades, con departamento) publicado en
// el CDN por pawer-backend (scripts/geo/build-argentina-geo.js, datos de Georef). Es
// estático: se cachea en memoria por sesión. Los archivos son públicos, no llevan token.
const cache = { provincias: null, localidades: {} };

const PROVINCIA_CODE = /^\d{2}$/;

const geoUrl = () => process.env.VUE_APP_AR_GEO_URL;

export default class ArgentinaGeoService {
  // [{ codigo: '06', nombre: 'Buenos Aires' }]
  static async getProvincias() {
    if (cache.provincias) return { status: 'ok', data: cache.provincias };
    if (!geoUrl()) {
      console.error('VUE_APP_AR_GEO_URL no está configurada');
      return { status: 'error' };
    }
    try {
      const response = await axios.get(`${geoUrl()}/provincias.json`);
      // Un archivo sin su lista no se guarda: sería un catálogo roto presentado como válido.
      if (!Array.isArray(response.data.provincias)) {
        console.error('provincias.json de Argentina no trae la lista de provincias');
        return { status: 'error' };
      }
      cache.provincias = response.data.provincias;
      return { status: 'ok', data: cache.provincias };
    } catch (error) {
      console.error('No se pudo cargar el catálogo de provincias de Argentina', error);
      return { status: 'error' };
    }
  }

  // [{ codigo: '0649001001', nombre: 'Banfield', departamento: 'Lomas de Zamora' }] de la
  // provincia (código de 2 dígitos). El código de localidad tiene 8 o 10 dígitos.
  static async getLocalidades(provinciaCode) {
    // El formato también deja el código seguro para armar la URL del CDN.
    if (!PROVINCIA_CODE.test(String(provinciaCode ?? ''))) return { status: 'error' };
    if (cache.localidades[provinciaCode]) {
      return { status: 'ok', data: cache.localidades[provinciaCode] };
    }
    if (!geoUrl()) {
      console.error('VUE_APP_AR_GEO_URL no está configurada');
      return { status: 'error' };
    }
    try {
      const response = await axios.get(`${geoUrl()}/localidades/${provinciaCode}.json`);
      if (!Array.isArray(response.data.localidades)) {
        console.error(`El archivo de localidades de la provincia ${provinciaCode} no trae la lista`);
        return { status: 'error' };
      }
      cache.localidades[provinciaCode] = response.data.localidades;
      return { status: 'ok', data: cache.localidades[provinciaCode] };
    } catch (error) {
      console.error(`No se pudo cargar las localidades de la provincia ${provinciaCode}`, error);
      return { status: 'error' };
    }
  }
}
